<div>
  <jhi-bary-title [title]="label" titleClass="bold text-dark mb-2" [tooltip]="tooltip"></jhi-bary-title>
  <div class="switch">
    <label class="d-flex flex-wrap align-items-center" [class.disabled]="disabled" [class.withColor]="withColor">
      {{ offLabel }}
      <input type="checkbox" [id]="id" [mdbValidate]="true" [formControl]="control" [validateSuccess]="false" (change)="handleChange()" [name]="name" />
      <span class="lever"></span>
      <span class="d-flex flex-nowrap align-items-center" [mdbTooltip]="tooltipOnLabel ?? ''">
        {{ onLabel }}
        <jhi-bary-icon *ngIf="tooltipOnLabel" icon="info-circle" [faDirective]="FAS" class="ml-1"></jhi-bary-icon>
      </span>
    </label>
  </div>
</div>
